import { render, staticRenderFns } from "./DInputPreview.vue?vue&type=template&id=20324e67&"
import script from "./DInputPreview.vue?vue&type=script&lang=js&"
export * from "./DInputPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports